import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const Loading = ({ size = 24, tip }) => {
  if (!tip) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: size }} spin />} />
      </div>
    );
  }
  
  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      minHeight: '200px',
      width: '100%'
    }}>
      <Spin 
        tip={tip} 
        indicator={<LoadingOutlined style={{ fontSize: size }} spin />}
      />
    </div>
  );
};

export default Loading;
